import { StyledBadgeContentWrapper, StyledBadgeRoot, StyledIconWrapper } from './Badge.styled';
import type { BadgeProps } from './Badge.types';

export const Badge = (props: BadgeProps) => {
  const {
    size = 'XS',
    variant = 'circle',
    content,
    bgColor,
    color,
    maxCount,
    children,
    anchorOrigin = 'top.right',
    anchorOffset,
    styledComponents,
  } = props;

  const innerContent =
    typeof content === 'number' && maxCount
      ? content > (maxCount || 0)
        ? `${maxCount}+`
        : content
      : content;
  const IconContent = typeof innerContent === 'function' && innerContent;

  return (
    <StyledBadgeRoot {...(styledComponents?.root && styledComponents?.root)}>
      {children && children}
      <StyledBadgeContentWrapper
        anchorOffset={anchorOffset}
        anchorOrigin={anchorOrigin}
        bgColor={bgColor}
        color={color}
        hasPadding={typeof content === 'number' || typeof content === 'string'}
        hasWrappingChildren={!!children}
        {...(variant !== 'lgDot' && variant !== 'smDot' && { size })}
        variant={variant}
        {...(styledComponents?.content && styledComponents?.content)}
      >
        {IconContent ? (
          <StyledIconWrapper>
            <IconContent />
          </StyledIconWrapper>
        ) : (
          innerContent
        )}
      </StyledBadgeContentWrapper>
    </StyledBadgeRoot>
  );
};
